import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { RIVER_ICE, RIVER_ICE_VECTOR } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import DataActions from '../redux/dataRedux'

const id = 'river-ice-athabasca'

export class RiverIce extends Component {
  state = {
    currentTime: new Date().getTime(),
    times: [
      {
        time: new Date('2019-04-15T13:27:37Z').getTime(),
        layers: {
          'river-ice-athabasca': {
            id: 'river-ice-athabasca',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/river-ice-athabasca/2019-04-15/{z}/{x}/{y}.pbf`
          },
        }
      },
      {
        time: new Date('2019-04-09T01:03:03Z').getTime(),
        layers: {
          'river-ice-athabasca': {
            id: 'river-ice-athabasca',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/river-ice-athabasca/2019-04-09/{z}/{x}/{y}.pbf`
          },
        }
      },
      {
        time: new Date('2019-04-08T13:36:49Z').getTime(),
        layers: {
          'river-ice-athabasca': {
            id: 'river-ice-athabasca',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/river-ice-athabasca/2019-04-08/{z}/{x}/{y}.pbf`
          },
        }
      },
      {
        time: new Date('2019-04-01T13:40:53Z').getTime(),
        layers: {
          'river-ice-athabasca': {
            id: 'river-ice-athabasca',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/river-ice-athabasca/2019-04-01/{z}/{x}/{y}.pbf`
          },
        }
      },
      {
        time: new Date('2019-03-29T01:23:26Z').getTime(),
        layers: {
          'river-ice-athabasca': {
            id: 'river-ice-athabasca',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/river-ice-athabasca/2019-03-29/{z}/{x}/{y}.pbf`
          },
        }
      },
      {
        time: new Date('2019-03-26T01:11:10Z').getTime(),
        layers: {
          'river-ice-athabasca': {
            id: 'river-ice-athabasca',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/river-ice-athabasca/2019-03-26/{z}/{x}/{y}.pbf`
          },
        }
      },
      {
        time: new Date('2019-03-22T13:32:33Z').getTime(),
        layers: {
          'river-ice-athabasca': {
            id: 'river-ice-athabasca',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/river-ice-athabasca/2019-03-22/{z}/{x}/{y}.pbf`
          },
        }
      },
      {
        time: new Date('2019-03-15T02:32:02Z').getTime(),
        layers: {
          'river-ice-athabasca': {
            id: 'river-ice-athabasca',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/river-ice-athabasca/2019-03-15/{z}/{x}/{y}.pbf`
          },
        }
      },
      {
        time: new Date('2019-03-09T01:07:06Z').getTime(),
        layers: {
          'river-ice-athabasca': {
            id: 'river-ice-athabasca',
            url: `https://coresight-layers.s3-us-west-2.amazonaws.com/river-ice-athabasca/2019-03-09/{z}/{x}/{y}.pbf`
          },
        }
      },
    ]
  }

  getLayerUrl = ({ time, id }) => {
    const { times } = this.state

    const item = times.find(item => time >= item.time)

    const url = item ? item.layers[id].url : times[0].layers[id].url

    return url
  }

  componentDidMount () {
    const { map } = this.context
    if (!map) { return }
    map.on('mouseover', id, this.handleMouseOver)
    map.on('mouseout', id, this.handleMouseOut)
    map.on('mousemove', id, this.handleMouseMove)
  }

  componentWillUnmount () {
    const { map } = this.context
    if (!map) { return }
    map.off('mouseover', id, this.handleMouseOver)
    map.off('mouseout', id, this.handleMouseOut)
    map.off('mousemove', id, this.handleMouseMove)
  }
  
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  handleMouseMove = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })
    const data = features.map(feature => feature.properties)

    if (data) {
      // console.log(data[0])
      actions.dataUpdated(data[0], 'hover')
    }
  }

  handleMouseOver = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    // console.log('mouse over', layerRendered)
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })

    map.getCanvas().style.cursor = features.length > 0 ? 'pointer' : ''
  }

  handleMouseOut = event => {
    const { map } = this.context
    const { actions } = this.props

    map.getCanvas().style.cursor = ''

    map.getCanvas().style.cursor = ''
    actions.dataUpdated({}, 'hover')
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''

    if (!visible) {
      return null
    }

    return (
      <>
        <Source id={'river-ice-athabasca'} tileJsonSource={{
          type: 'vector',
          // tiles: [`https://coresight-layers.s3-us-west-2.amazonaws.com/river-ice-athabasca/{z}/{x}/{y}.pbf`],
          tiles: [this.getLayerUrl({ id: 'river-ice-athabasca', time: time })],
          tileSize: 512,
          minzoom: 1,
          maxzoom: 18
        }} />
        <Layer
          type='fill'
          id={'river-ice-athabasca'}
          sourceId={'river-ice-athabasca'}
          sourceLayer={'river-ice'}
          paint={{
            'fill-color': [
              'match',
              ['get', 'gridcode'],
              1, '#044A8F',
              2, '#6BC0E9',
              3, '#FAF703',
              4, '#DC440C',
              'black'
              ]
          }}
        />
      </>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, 'RiverIce'),
      paint: getPaint(state, 'RiverIce'),
      time: state.layer.times.RiverIce || undefined
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(RiverIce)



// WEBPACK FOOTER //
// ./src/layers/RiverIce.js